import React from "react";

import * as R from "ramda";

import { Query } from "react-apollo";
import { translate } from "react-i18next";

import { getErrors } from "./errors";

const getConnectionProps = ({ data, lens, fetchMore, query, variables }) => {
  const connection = R.view(lens, data);

  if (!connection) {
    return {};
  }

  const nodes = R.pipe(
    R.map(R.prop("node")),
    R.reject(R.propEq("deleted", true))
  )(connection.edges);

  const cursor = connection.pageInfo.endCursor;

  const updateQuery = (previousResult, { fetchMoreResult }) => {
    const { edges, pageInfo } = R.view(lens, fetchMoreResult);

    return R.over(
      lens,
      R.evolve({
        edges: R.concat(R.__, edges),
        pageInfo: R.always(pageInfo),
      }),
      previousResult
    );
  };

  const loadMore = cursor
    ? () =>
        fetchMore({
          query,
          variables: { ...variables, cursor },
          updateQuery: updateQuery,
        })
    : null;

  return {
    loadMore,
    nodes,
  };
};

const ConnectionQuery = ({
  children,
  query,
  variables,
  connectionPath,
  renderErrors,
  t,
  lens = R.lensPath(connectionPath),
}) => (
  <Query query={query} variables={variables} notifyOnNetworkStatusChange={true}>
    {({ error, loading, data, fetchMore }) => {
      if (error) {
        const { errorMessages, authenticationErrors } = getErrors(error, t);

        return authenticationErrors && authenticationErrors.length
          ? null // This state is handled by the client
          : renderErrors
          ? renderErrors({ errorMessages })
          : null;
      }

      const { loadMore, nodes } = getConnectionProps({
        data,
        lens,
        fetchMore,
        query,
        variables,
      });

      return children({
        nodes,
        loadMore,
        loading,
        data,
      });
    }}
  </Query>
);

export default translate("translations")(ConnectionQuery);



// WEBPACK FOOTER //
// ./src/graphql/ConnectionQuery.js